import { rem } from 'polished'
import React, { useCallback, useContext } from 'react'
import styled from 'styled-components'

import TextButton from 'components/Luxkit/Button/TextButton'
import LineGlobeAltIcon from 'components/Luxkit/Icons/line/LineGlobeAltIcon'
import LinePlusCircleIcon from 'components/Luxkit/Icons/line/LinePlusCircleIcon'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'
import { ModalElementContext } from 'contexts/ModalProvider'
import CreateTrip from 'tripPlanner/components/TripModal/Trips/CreateTrip'

const Content = styled(Group)`
  margin: ${rem(40)} ${rem(20)};
  padding: ${rem(20)};

  ${mediaQueryUp.sm} {
    margin: ${rem(20)} ${rem(80)};
    padding: ${rem(80)} 0;
  }
`

interface Props {
  isNavigateToTripSummaryOnCreate?: boolean
}

function MyTripsEmpty({ isNavigateToTripSummaryOnCreate }: Props) {
  const showModal = useContext(ModalContext)
  const modalElement = useContext(ModalElementContext)

  const dismissModal = useCallback(() => {
    modalElement?.resolve()
  }, [modalElement])

  const createNewTrip = useCallback(() => {
    showModal(
      <ModalBase>
        <CreateTrip isNavigateToTripSummary={isNavigateToTripSummaryOnCreate} />
      </ModalBase>,
    )
  }, [isNavigateToTripSummaryOnCreate, showModal])
  return (
    <Content direction="vertical" gap={16} horizontalAlign="center">
      <LineGlobeAltIcon size="L" />
      <Group direction="vertical" gap={8} horizontalAlign="center">
        <Heading variant="heading4">Start building your next trip</Heading>
        <BodyText variant="medium" colour="neutral-three" align="center">
          Save offers, explore destinations, create an itinerary, and arrange
          every aspect of your escape.
        </BodyText>
      </Group>
      <Group
        direction="vertical-reverse"
        smDirection="horizontal"
        gap={8}
        verticalAlign="center"
      >
        <TextButton
          kind="tertiary"
          to="/trip-planner/about"
          onClick={dismissModal}
        >
          What is TripPlanner?
        </TextButton>
        <TextButton
          kind="primary"
          onClick={createNewTrip}
          startIcon={<LinePlusCircleIcon />}
          data-testid="create-new-trip-button"
        >
          Create new trip
        </TextButton>
      </Group>
    </Content>
  )
}

export default MyTripsEmpty
